import {
  Box,
  Card,
  Checkbox,
  FormLayout,
  InlineStack,
  TextField,
} from "@shopify/polaris";

const PriceAndInventory = ({
  price,
  setPrice,
  onSale,
  setOnSale,
  discount,
  setDiscount,
  inventory,
  setInventory,
  trackInventory,
  setTrackInventory,
  editable,
  setProfit,
  compareAtPrice,
  setCompareAtPrice,
}) => {
  return (
    <Card title="Bundle Pricing" sectioned>
      <FormLayout>
        {/* <InlineStack gap={"100"} align="space-between" wrap={false}> */}
        <Box>
          <InlineStack align="space-between" gap={"1000"}>
            <TextField
              // size="medium"
              label="Price"
              value={price}
              placeholder="e.g. 1800"
              onChange={(value) => setPrice(value)}
              type="number"
              prefix="₹"
              disabled={!editable}
            />
            <TextField
              // size="medium"
              label="Compare at price"
              value={compareAtPrice}
              placeholder="e.g. 2000"
              onChange={(value) => setCompareAtPrice(value)}
              type="number"
              prefix="₹"
              disabled={!editable}
            />
            {/* <Box>
              <TextField
                label="Inventory"
                value={inventory}
                placeholder={trackInventory ? `e.g 20 ` : ""}
                onChange={(value) => setInventory(value)}
                type="number"
                disabled={!editable}
              />
              <br />
              <Checkbox
                label="Track Inventory"
                checked={trackInventory}
                onChange={(value) => {
                  if (!value) {
                    setInventory("");
                  }
                  setTrackInventory(value);
                }}
                disabled={!editable}
              />
            </Box> */}
            {/* <br /> */}
          </InlineStack>
          {/* <Checkbox
              label="On Sale"
              checked={onSale}
              onChange={(value) => {
                if (!value) {
                  setDiscount("");
                }
                setOnSale(value);
              }}
              disabled={!editable}
            /> */}
        </Box>
        {/* </InlineStack> */}
        {/* {onSale ? (
          <InlineStack gap={"1000"}>
            <TextField
              label="Discount"
              value={discount}
              onChange={(value) => setDiscount(value)}
              type="number"
              prefix="₹"
              disabled={!editable}
            />
            <TextField
              label="Net Price"
              value={Number(price) - discount ?? 0}
              // onChange={(value) => setProfit(value)}
              type="number"
              prefix="₹"
              disabled={true}
            />
          </InlineStack>
        ) : (
          ""
        )} */}
      </FormLayout>
    </Card>
  );
};

export default PriceAndInventory;
